 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		33: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		33: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"29107295","2":"commons","3":"5f0e8ebd107c0fecc272f1bc13d4e8f41512a0bb","4":"8241d4e96010c484f7c5aad4cf0d718dbe9890c6","5":"d234652870d2e83915b8505686297acb4e165bfa","6":"891553996b91f1246d9bac3f2167783fff413057","7":"1baac3fc","8":"24faf0f5","9":"5b8f9af0","10":"6193cd58","11":"df3d01e43d74b1172ea5818d23906c96f72b2ba9","12":"e844c5c1","13":"0ca3046934e10e4af8ed902f6d2c111383af5987","14":"3421c2197f9615d1b3974f794301c86e251aa1d9","15":"ea88be26","16":"f1ca1cb1f737226d7a338ebd6576b5e3fc180446","17":"framework","18":"227ec61a5a8856276adb18501b645a89cd0b6649","19":"d18f30b8c8442af8bf3965a2bcf6edbf5d53589e","20":"f66b08783d56b515753e8e48fc3b08e5520e3765","21":"06f6b0c0","22":"185320330a1cf8a5f3cd7debcf748d574efe791e","23":"324e634e56b7bf8334cc15fa0433351d1f7883a6","24":"54b82ca6","25":"5e2a4920","26":"6763fea0","27":"7f26a014","28":"8cfd07f9","29":"bb4af6f12b99be8447b3872773ad4a3bf0f6db44","30":"d3560fe709b2b1e75a1e1e92bef0674e308f4d77","31":"d64684d8","32":"ef6529d7","35":"54a8060e","36":"a4d41944","38":"component---src-pages-404-js","39":"component---src-pages-index-js","40":"component---src-pages-portfolio-js","41":"component---src-templates-blog-list-js","42":"component---src-templates-blog-post-js","43":"component---src-templates-case-js","44":"component---src-templates-category-blog-list-js","45":"component---src-templates-dynamic-page-js","46":"component---src-templates-landing-page-devsquad-js","47":"component---src-templates-landing-page-devsquad-v-2-js","48":"component---src-templates-landing-page-js","49":"component---src-templates-landing-page-v-2-js","50":"component---src-templates-obrigado-js","51":"component---src-templates-servicos-js","52":"component---src-templates-solicitar-orcamento-js","53":"component---src-templates-trabalhe-conosco-js","54":"component---src-templates-x-apps-na-midia-js","56":"reactPlayerDailyMotion","57":"reactPlayerFacebook","58":"reactPlayerFilePlayer","59":"reactPlayerKaltura","60":"reactPlayerMixcloud","61":"reactPlayerMux","62":"reactPlayerPreview","63":"reactPlayerSoundCloud","64":"reactPlayerStreamable","65":"reactPlayerTwitch","66":"reactPlayerVidyard","67":"reactPlayerVimeo","68":"reactPlayerWistia","69":"reactPlayerYouTube"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"376bf8e1f6c2d7303ac8","2":"7b685dffe2df17b0c22d","3":"dfdaf642d72758fa4dd0","4":"6ebc950808128201b005","5":"321265d654f23292ca8d","6":"c8625b8c1334b149c137","7":"4f22c03709ca4ecc7c20","8":"ae375c9a43f901b89af3","9":"e03292baa528d5ba867a","10":"1ddf2f533ad5f1266eec","11":"4e6c83a75c5d54466387","12":"7313bc4d476fe7d6d3b7","13":"40df1dd655ee13be477c","14":"07494412391a232e3f4c","15":"a785750142ef45da0e0c","16":"92630100840664adf19b","17":"83cbbae6138e11828071","18":"8117b0afcd194a07dc14","19":"2b6c4a62143ff599f89a","20":"a24cb3611678d89ca17c","21":"8f634cb7fdf4ac4cc166","22":"851804362de20117dc6a","23":"5fb59fdc44ac0a08d65b","24":"2629699fd807707539e1","25":"b2baf800de9d59470dd3","26":"e4530f1cc6754b44eada","27":"6638bb5e28ca4a1e4720","28":"f05583c82e74a13c5e42","29":"e9e5c4eed05f0581dac2","30":"ff25a3e1dea49b7b9230","31":"ac4200010a6e34e94f7e","32":"e91deaed7e350827bf25","35":"56c0d8370298f5c42f21","36":"6548b4c7e48978897041","38":"ec8798efd27bc856cc29","39":"f7ea236e5b102cd9c0ba","40":"ac7925a2b222c1650653","41":"529b50fc455797ab3e1f","42":"d048e9393c7b5382308d","43":"9ddea502f0b7510e7c18","44":"a693d07c64d53c95f88a","45":"557faeb9590b403bc64f","46":"c36f9607813ffb3f5ec4","47":"d4705a405c40037d009d","48":"eebad277851e91702c78","49":"b0139e9b608bdd3d2378","50":"85157d0e7b859ca2540f","51":"f5c64f0003e3d07c3420","52":"165a2db5246adafdca19","53":"e1d5689924a1fdf47a77","54":"85f9078ca336ca23f9d5","56":"2525a1459e5a7cfbc198","57":"34b4ba2e6969d104404b","58":"0678ae5e37cfa43593ad","59":"7cb38323504b554de87a","60":"0feaf308379d2cdf4504","61":"9f18fcefde7453d9e98b","62":"8137318bf281d96bfe9f","63":"7e4d9e33cf7364b454c1","64":"5b3debe6a34e4cfdeea0","65":"80272ff68164ece698a2","66":"684458c317a3c7d8e862","67":"d9b1fe4d42c5942453e3","68":"b76a0ace1fb02aa6e4d7","69":"094e2213553ce55fddee"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"29107295","2":"commons","3":"5f0e8ebd107c0fecc272f1bc13d4e8f41512a0bb","4":"8241d4e96010c484f7c5aad4cf0d718dbe9890c6","5":"d234652870d2e83915b8505686297acb4e165bfa","6":"891553996b91f1246d9bac3f2167783fff413057","7":"1baac3fc","8":"24faf0f5","9":"5b8f9af0","10":"6193cd58","11":"df3d01e43d74b1172ea5818d23906c96f72b2ba9","12":"e844c5c1","13":"0ca3046934e10e4af8ed902f6d2c111383af5987","14":"3421c2197f9615d1b3974f794301c86e251aa1d9","15":"ea88be26","16":"f1ca1cb1f737226d7a338ebd6576b5e3fc180446","17":"framework","18":"227ec61a5a8856276adb18501b645a89cd0b6649","19":"d18f30b8c8442af8bf3965a2bcf6edbf5d53589e","20":"f66b08783d56b515753e8e48fc3b08e5520e3765","21":"06f6b0c0","22":"185320330a1cf8a5f3cd7debcf748d574efe791e","23":"324e634e56b7bf8334cc15fa0433351d1f7883a6","24":"54b82ca6","25":"5e2a4920","26":"6763fea0","27":"7f26a014","28":"8cfd07f9","29":"bb4af6f12b99be8447b3872773ad4a3bf0f6db44","30":"d3560fe709b2b1e75a1e1e92bef0674e308f4d77","31":"d64684d8","32":"ef6529d7","35":"54a8060e","36":"a4d41944","38":"component---src-pages-404-js","39":"component---src-pages-index-js","40":"component---src-pages-portfolio-js","41":"component---src-templates-blog-list-js","42":"component---src-templates-blog-post-js","43":"component---src-templates-case-js","44":"component---src-templates-category-blog-list-js","45":"component---src-templates-dynamic-page-js","46":"component---src-templates-landing-page-devsquad-js","47":"component---src-templates-landing-page-devsquad-v-2-js","48":"component---src-templates-landing-page-js","49":"component---src-templates-landing-page-v-2-js","50":"component---src-templates-obrigado-js","51":"component---src-templates-servicos-js","52":"component---src-templates-solicitar-orcamento-js","53":"component---src-templates-trabalhe-conosco-js","54":"component---src-templates-x-apps-na-midia-js","56":"reactPlayerDailyMotion","57":"reactPlayerFacebook","58":"reactPlayerFilePlayer","59":"reactPlayerKaltura","60":"reactPlayerMixcloud","61":"reactPlayerMux","62":"reactPlayerPreview","63":"reactPlayerSoundCloud","64":"reactPlayerStreamable","65":"reactPlayerTwitch","66":"reactPlayerVidyard","67":"reactPlayerVimeo","68":"reactPlayerWistia","69":"reactPlayerYouTube"}[chunkId]||chunkId) + "." + {"0":"8320000e34ba442247b6","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
